module.exports = __webpack_public_path__ + "img/share.c2a011d1.svg";